export const adaptTipoProfesional = (tipoProfesionalData) => {
    return {
        value: tipoProfesionalData?.idTipoProfesional,
        id: tipoProfesionalData?.idTipoProfesional,
        displayName: tipoProfesionalData?.descripcion,
        label: tipoProfesionalData?.descripcion
    }
}

export const adaptTipoProfesionalArray = (
    tipoProfesionales
) => {
    return structuredClone(tipoProfesionales?.allTipoProfesional)
        ?.map(tipoProfesional => adaptTipoProfesional(tipoProfesional));
}